// Utility to reduce an image to 8x8 grayscale for comparison
const getImageHash = async (base64Image) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      // Create small canvas for the hash
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 8;
      canvas.height = 8;

      // Draw and reduce image
      ctx.drawImage(img, 0, 0, 8, 8);
      const imageData = ctx.getImageData(0, 0, 8, 8).data;

      // Calculate average brightness
      let sum = 0;
      for (let i = 0; i < imageData.length; i += 4) {
        // Convert to grayscale
        const brightness = (imageData[i] * 0.299 + imageData[i + 1] * 0.587 + imageData[i + 2] * 0.114);
        sum += brightness;
      }
      const avgBrightness = sum / (64); // 8x8 pixels

      // Generate hash based on whether pixel is brighter than average
      let hash = '';
      for (let i = 0; i < imageData.length; i += 4) {
        const brightness = (imageData[i] * 0.299 + imageData[i + 1] * 0.587 + imageData[i + 2] * 0.114);
        hash += brightness > avgBrightness ? '1' : '0';
      }

      resolve(hash);
    };
    img.src = base64Image;
  });
};

// Calculate Hamming distance between two hashes
const hammingDistance = (hash1, hash2) => {
  let distance = 0;
  for (let i = 0; i < hash1.length; i++) {
    if (hash1[i] !== hash2[i]) distance++;
  }
  return distance;
};

// Compare two images and return true if they are sufficiently different
export const areImagesDifferent = async (image1, image2, threshold = 10) => {
  const hash1 = await getImageHash(image1);
  const hash2 = await getImageHash(image2);
  return hammingDistance(hash1, hash2) > threshold;
};